import type { IUseTgnDialog } from './TgnDialog';

export function useTgnDialog(): IUseTgnDialog {
  const dialogDataTest = ref('tgn-dialog');
  const dialogVisible = ref(false);
  const dialogText = ref('Text');
  const dialogTitle = ref('Title');
  const openDialog = () => {
    dialogVisible.value = true;
  };
  const closeDialog = () => {
    dialogVisible.value = false;
  };

  return {
    dialogDataTest,
    dialogVisible,
    dialogText,
    dialogTitle,
    closeDialog,
    openDialog,
  };
}
